// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { Settings } from "src/app/modules/common/lib/app.constant";

export const environment = {
  production: false,
   allowUrl: [
    'http://localhost:4300',
    'https://astrodev.dfds.com'
  ],
  environmentType:Settings.EnvironmentType.DEV,
  baseApiUrl:'https://app-dfds-astro-webapi-dev-weu-001.azurewebsites.net/api/',
  // baseApiUrl:'https://app-dfds-astro-webapi-tst-weu-002.azurewebsites.net/api/',
    // baseApiUrl:'https://app-dfds-astro-webapi-uat-weu-002.azurewebsites.net/api/',


  appInsights: {
    instrumentationKey: null
  },
  sso:{
    adClientId:'0099b070-609e-426c-a09d-4ded0b3fffe5',
    adTenantId : '73a99466-ad05-4221-9f90-e7142aa2f6c1'
  },
  msalLogInRequest : ['api://0099b070-609e-426c-a09d-4ded0b3fffe5/api-access']
};
